/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useDispatch } from 'react-redux'
import { adminPasswordUpdate } from 'store/userManagement/slice'

const changePasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(4, 'Password is too short - should be 4 chars min'),
  confirmPassword: Yup.string()
    .required('Confirm Password is required')
    .oneOf(
      [Yup.ref('password'), null],
      'Password & Confirm Password must match',
    ),
})

const SetPassword = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const search = useLocation().search

  const [initialValues] = useState({
    password: '',
    confirmPassword: '',
  })

  const handleSubmit = (values: {
    email: string
    password: string
    confirmPassword: string
  }) => {
    const newValues: any = {
      email: email,
      password: values.password,
      confirmPassword: values.confirmPassword,
    }
    dispatch(adminPasswordUpdate({ data: newValues, navigate }))
  }

  useEffect(() => {
    const emailParam = new URLSearchParams(search).get('validation')
    if (emailParam) {
      const email = decodeURIComponent(emailParam)
      const encodedEmail = email.replace(/ /g, '+')
      setEmail(encodedEmail)
    }
  }, [search])

  return (
    <section className="sign-in-page">
      <div className="container h-100">
        <div className="row justify-content-center align-items-start height-self-center">
          <div className="col-12 h-100">
            {/* <p className="w-100">Logo</p> */}
            <div
              className=" d-flex align-items-center justify-content-center"
              style={{ height: '90%' }}
            >
              <div className="col-lg-5 col-md-12 align-self-center form-padding">
                <div className="sign-user_card ">
                  <div className="sign-in-page-data">
                    <div className="sign-in-from w-100 m-auto">
                      <h3 className="mb-3 text-center sign-in-font-color ">
                        Set Password
                      </h3>
                      <Formik
                        initialValues={initialValues}
                        validationSchema={changePasswordSchema}
                        onSubmit={(values: {
                          email: string
                          password: string
                          confirmPassword: string
                        }) => {
                          handleSubmit(values)
                        }}
                      >
                        {(formik: { errors: any; touched: any }) => {
                          const { errors, touched } = formik
                          return (
                            <Form className="mt-4">
                              <div className="form-group">
                                <Field
                                  type="password"
                                  name="password"
                                  id="password"
                                  className="form-control  mb-0"
                                  placeholder="Enter Password"
                                />
                                <ErrorMessage
                                  name="password"
                                  component="span"
                                  className="text-primary"
                                />
                              </div>
                              <div className="form-group">
                                <Field
                                  type="password"
                                  name="confirmPassword"
                                  id="confirmPassword"
                                  className="form-control  mb-0"
                                  placeholder="Confirm Password"
                                />
                                <ErrorMessage
                                  name="confirmPassword"
                                  component="span"
                                  className="text-primary"
                                />
                              </div>
                              <div className="sign-info">
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  continue
                                </button>
                              </div>
                            </Form>
                          )
                        }}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SetPassword
